import React, {useCallback, useState, useEffect} from "react";
import {useDropzone} from 'react-dropzone'
import "./UploadPhoto.scss"
import imgVector from './img/duplicate-cuate.svg'
import {RaikoGridOneColumn, showWarningMessage} from "@moeindal/base-raiko-panel-components";

const UploadPhoto = (
    {
        photo = [],
        setPhoto,
        setPhotoFile,
        isSingleSelect = true,
        maxSize = 1024 * 1000
    }) => {


    const [files, setFiles] = useState([]);


    useEffect(() => {
        setPhotoFile(files)
    }, [files]);


    const onDrop = useCallback((acceptedFiles, rejectedFiles) => {
        if (acceptedFiles?.length) {
            if (isSingleSelect) {
                setFiles([])
                setPhoto([])
                setFiles(
                    [Object.assign(acceptedFiles[0], {preview: URL.createObjectURL(acceptedFiles[0])})]
                )
            } else {
                setFiles(prevFiles => [
                    ...prevFiles,
                    ...acceptedFiles.map(file =>
                        Object.assign(file, {preview: URL.createObjectURL(file)}))
                ])
            }
        }
        if (rejectedFiles.length > 0) {
            showWarningMessage(`حداکثر حجم فایل انتخابی می بایست ${maxSize / 1024000} مگابایت باشد`)
        }

    }, [])
    const {getRootProps, getInputProps, isDragActive} = useDropzone(
        {
            onDrop
            , accept: {
                'image/png': ['.png'],
                'image/jpeg': ['.jpeg'],
                'image/jpg': ['.jpg'],
            },
            maxSize: maxSize
        })

    return (
        <section className={"baseUploadPhotoSectionContainer"}>
            <RaikoGridOneColumn>
                <div {...getRootProps({
                    className: "baseUploadPhotoContainer"
                })}>
                    {
                        files && files.length > 0 ?
                            files.map((file, index) => {
                                return <div className={"imageContainer"}>
                                    <img src={file.preview} alt=""/>
                                </div>
                            }) :
                            photo && photo.length > 0 ?
                                photo.map((file, index) => {
                                    return <div className={"imageContainer"}>
                                        <img src={file} alt=""/>
                                    </div>
                                }) :
                                <img src={imgVector} alt=""/>
                    }
                    <input {...getInputProps()} />
                    {
                        isDragActive ?
                            <p>فایل را اینجا رها کنید...</p> :
                            <p>فایل مورد نظر را اینجا بکشید و یا برای انتخاب فایل کلیک نمایید</p>
                    }
                </div>
            </RaikoGridOneColumn>
        </section>
    )
}
export default UploadPhoto